// To use in react component to prevent rerenders (checks are done by ref for objects)
export const EMPTY_OBJECT = Object.freeze({});

export const EMPTY_ARRAY = Object.freeze([]);
